// @ts-nocheck
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import modalReducer from '@/store/slices/modalSlice';
import sideReducer from '@/store/slices/sideSlice';
import toolSideReducer from '@/store/slices/toolSideSlice';
import toolReducer from '@/features/tool/slices/toolSlice';
import toastReducer from '@/store/slices/toastSlice';
import configReducer from '@/store/slices/configSlice';
import planReducer from '@/store/slices/planSlice';
import paymentReducer from '@/store/slices/paymentSlice';
import userAccessReducer from '@/store/slices/userAccessSlice';
import { baseApi } from '@/lib/api/baseApi';
import authReducer from '@/store/slices/authSlice';
import uploadReducer from '@/features/tool/slices/uploadSlice';
import { loadState, saveState } from '@/helpers/localStoragehelper';
import unsavedChangesReducer from '@/store/slices/unsavedChangesSlice';
import reviewReducer from '@/features/review-flow/store/reviewSlice';
import checkoutReturnReducer from '@/store/slices/checkoutReturnSlice';

// Load persisted state
const persistedState = loadState();

export const store = configureStore({
  preloadedState: persistedState,
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    plan: planReducer,
    payment: paymentReducer,
    modal: modalReducer,
    side: sideReducer,
    toolSide: toolSideReducer,
    tool: toolReducer,
    toast: toastReducer,
    config: configReducer,
    userAccess: userAccessReducer,
    upload: uploadReducer,
    unsavedChanges: unsavedChangesReducer,
    review: reviewReducer,
    checkoutReturn: checkoutReturnReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: [
          'tool.files',
          'tool.exportAsFiles',
          'modal.modals',
          'toolSide.toolSideData',
          'checkoutReturn.lastCheckoutFile.file',
        ],
        ignoredActions: [
          'tool/setFiles',
          'tool/setExportAsFiles',
          'toolSide/showToolSide',
          'modal/showModal',
          'checkoutReturn/setLastCheckoutFile',
        ],
      },
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

// Save state to localStorage on changes
store.subscribe(() => {
  saveState({
    auth: store.getState().auth,
  });
});

export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
